if (!customElements.get('announcement-bar')) {
class AnnouncementBar extends HTMLElement {
	constructor() {
		super(), this.config = {
			autorotate: "true" === this.dataset.autorotate,
			autorotateSpeed: 1e3 * parseInt(this.dataset.autorotateSpeed),
			moveTime: parseFloat(this.dataset.speed),
			space: 100
		}, theme.config.mqlSmall ? this.initOnMobile() : this.initOnDesktop(), document.addEventListener("matchSmall", () => {
			this.unload(), this.initOnMobile()
		}), document.addEventListener("unmatchSmall", () => {
			this.unload(), this.initOnDesktop()
		})
	}
	initOnDesktop() {
		switch (this.dataset.layout) {
			case "carousel":
				this.initCarousel();
				break;
			case "marquee":
				this.initMarquee();
				break;
			default:
				this.initMarqueeOptimized()
		}
	}
	initOnMobile() {
		switch (this.dataset.mobileLayout) {
			case "carousel":
				this.initCarousel();
				break;
			case "marquee":
				this.initMarquee()
		}
	}
	unload() {
		this.flickity && "function" == typeof this.flickity.destroy && (this.flickity.destroy(), this.removeNextPrevListeners()), this.classList.contains("marquee") && (this.classList.remove("marquee"), this.querySelectorAll(".announcement-slider[aria-hidden]").forEach(e => {
			e.remove()
		})), this.observer && "function" == typeof this.observer.unobserve && this.observer.unobserve(this)
	}
	initCarousel() {
		if (1 == this.dataset.blockCount) return;
		let e = this.querySelector(".announcement-slider");
		setTimeout(() => {
			this.flickity = new Flickity(e, {
				accessibility: !1,
				rightToLeft: theme.config.rtl,
				prevNextButtons: !1,
				pageDots: !1,
				wrapAround: !0,
				setGallerySize: !1,
				autoPlay: !!this.config.autorotate && this.config.autorotateSpeed
			})
		}), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), this.onNextPrevClick = this.handleNextPrevClick.bind(this), this.prevButton && this.prevButton.addEventListener("click", this.onNextPrevClick), this.nextButton && this.nextButton.addEventListener("click", this.onNextPrevClick)
	}
	removeNextPrevListeners() {
		this.prevButton && this.prevButton.removeEventListener("click", this.onNextPrevClick), this.nextButton && this.nextButton.removeEventListener("click", this.onNextPrevClick)
	}
	handleNextPrevClick(e) {
		e.preventDefault();
		let t = e.currentTarget;
		"next" === t.name ? this.flickity && this.flickity.next() : "previous" === t.name && this.flickity && this.flickity.previous()
	}
	initMarqueeOptimized() {
		setTimeout(() => {
			this.marqueeAnimation()
		}), this.observer = new IntersectionObserver((e, t) => {
			e.forEach(e => {
				e.isIntersecting ? this.isAnimated && this.classList.remove("marquee--paused") : this.isAnimated && this.classList.add("marquee--paused")
			})
		}, {
			rootMargin: "0px 0px 50px 0px"
		}), this.observer.observe(this), window.addEventListener("resize", this.marqueeAnimation.bind(this))
	}
	marqueeAnimation() {
		let e = this.querySelector(".announcement-slider");
		if (e.scrollWidth > this.clientWidth) {
			if (!this.isAnimated) {
				for (let t = 0; t < 2; t++) {
					let i = e.cloneNode(!0);
					i.setAttribute("aria-hidden", !0), this.appendChild(i)
				}
				this.classList.add("marquee"), this.style.setProperty("--duration", `${e.scrollWidth/this.config.space*this.config.moveTime}s`), this.isAnimated = !0
			}
		} else if (this.isAnimated) {
			for (let s = 0; s < 2; s++) this.removeChild(this.lastElementChild);
			this.classList.remove("marquee"), this.isAnimated = !1
		}
	}
	initMarquee() {
		setTimeout(() => {
			let e = this.querySelector(".announcement-slider");
			for (let t = 0; t < 10; t++) {
				let i = e.cloneNode(!0);
				i.setAttribute("aria-hidden", !0), this.appendChild(i)
			}
			this.classList.add("marquee"), this.style.setProperty("--duration", `${e.clientWidth/this.config.space*this.config.moveTime}s`)
		}), this.observer = new IntersectionObserver((e, t) => {
			e.forEach(e => {
				e.isIntersecting ? this.classList.remove("marquee--paused") : this.classList.add("marquee--paused")
			})
		}, {
			rootMargin: "0px 0px 50px 0px"
		}), this.observer.observe(this)
	}
}
customElements.define("announcement-bar", AnnouncementBar);
}